import t from '../common/localization'

export default {
  'androidAppName': {
    name: t('androidAppName'),
    type: 'string',
  },
  'androidPlay': {
    name: t('androidPlay'),
    type: 'boolean',
  },
  'androidUpdateDate': {
    name: t('androidUpdateDate'),
    type: 'date',
  },
  'androidPackage': {
    name: t('androidPackage'),
    type: 'string',
  },
  'androidMinVersion': {
    name: t('androidMinVersion'),
    type: 'number',
  },
  'androidCurrentVersion': {
    name: t('androidCurrentVersion'),
    type: 'number',
  },
  'androidUpdatePush': {
    name: t('androidUpdatePush'),
    type: 'boolean',
  },
  'androidUpdateFeatures': {
    name: t('androidUpdateFeatures'),
    type: 'string',
  },
  'androidFcmKey': {
    name: t('androidFcmKey'),
    type: 'string',
  },
  'iosAppName': {
    name: t('iosAppName'),
    type: 'string',
  },
  'iosPackage': {
    name: t('iosPackage'),
    type: 'string',
  },
  'iosFcmKey': {
    name: t('iosFcmKey'),
    type: 'string',
  },
  'mappedUser': {
    name: t('mappedUser'),
    type: 'number',
  },
  'mudfaa': {
      name: t('attributeMudfaa'),
      type: 'boolean',
    },
    'maldfau': {
      name: t('attributeMaldfau'),
      type: 'boolean',
    }
};
